<template>
  <el-table :data="tableData" border >
    <el-table-column type="expand" >
      <template slot-scope="scope">
        <div style="background:#EEF1F6;margin-left: 80px;">
          <el-table :data="scope.row.orderList" border :header-cell-style ="{color: '#606266'}"  >
            <el-table-column prop="orderNum" label="订单号" align="center" min-width="200px" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="iccid" label="ICCID" align="center" min-width="158px" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="payMoney" label="订单金额" align="center" min-width="100px" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="productName" label="套餐名" align="center" min-width="158px"></el-table-column>
            <el-table-column prop="operationName" label="运营商" align="center" min-width="158px"></el-table-column>
            <el-table-column prop="payTime" label="支付时间" align="center" min-width="158px"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="center" min-width="158px"></el-table-column>
          </el-table>
        </div>
      </template>
    </el-table-column>
    <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
    <el-table-column prop="alias" label="ICCID/代理商" align="center" min-width="200px" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="status" label="发票来源" align="center" width="120px">
      <template slot-scope="scope">
        <el-tag type="success" v-if="scope.row.sort == '用户充值'">{{scope.row.sort}}</el-tag>
        <el-tag type="warning" v-else-if="scope.row.sort == '代理商充值'">{{scope.row.sort}}</el-tag>
      </template>
    </el-table-column>
    <el-table-column prop="money" label="发票金额" align="center" width="100px"></el-table-column>
    <el-table-column prop="titleType" label="抬头类型" align="center" width="110px"></el-table-column>
    <el-table-column prop="type" label="发票类型" align="center" min-width="110"></el-table-column>
    <el-table-column prop="invoiceInformation" label="发票信息" align="center" width="300px">
      <template slot-scope="scope">
        <p class="invoiceInformation-p">抬头：{{scope.row.title}}</p>
        <p class="invoiceInformation-p">税号：{{scope.row.ein}}</p>
      </template>
    </el-table-column>
    <el-table-column prop="status" label="发票状态" align="center" width="80px">
      <template slot-scope="scope">
        <el-tag type="success" v-if="scope.row.status == '已通过' || scope.row.status == '已寄出'">{{scope.row.status}}</el-tag>
        <el-tag type="warning" v-else-if="scope.row.status == '审核中'">{{scope.row.status}}</el-tag>
        <el-tag type="danger" v-else-if="scope.row.status == '未通过'">{{scope.row.status}}</el-tag>
        <el-tag type="primary" v-else>{{scope.row.status}}</el-tag>
      </template>
    </el-table-column>
    <el-table-column prop="createTime" label="申请时间" align="center" min-width="124px"></el-table-column>
    <el-table-column prop="remark" label="备注" align="center" width="250px" :show-overflow-tooltip="true"></el-table-column>
  </el-table>
</template>
<script>
import { invoiceChildList} from "@/api/api.js"; //资费列表
export default {
  props: {
    invoiceid: {
      type: [Number]
    }
  },
  data() {
    return{
      tableData:[],
    }
  },
  methods: {
    // 状态转换
    inventoryStatusType(status) {
      let obj = {
        0: "未通过",
        1: "审核中",
        2: "已通过",
        3: "已开票",
        4: "已寄出",
        5: "其他",
        6: "已驳回",
        7: "不开票",
      };
      return obj[status];
    },
    // 获取列表的数据
    initData(){
      let params = {
        invoiceId:this.invoiceid
      };
      invoiceChildList(params).then(res => {
        if(res.data.code == 200){
          this.tableData = res.data.data;
          this.tableData.map((item,index)=>{
            item.type = item.type == 1 ? "电子普通发票" : "增值税专用发票";
            item.titleType = item.titleType == 1 ? "企业单位" : "个人/事业单位";
            item.status = this.inventoryStatusType(item.status);
            item.ein = item.ein == null ? "-" : item.ein;
            item.createTime = item.createTime.substr(0,16);
          })
        }
      })
    },
  },
  created() {
    this.initData();
  }
};
</script>

<style scoped lang="less">

</style>


